
import MuiIcon, { IconSizeT, IconVariantT } from 'components/MuiIcon';
import { useTranslation } from 'react-i18next';

// Subscribers

// Channels
import ShowChannel from './views/channels/Show';
import CreateChannel from './views/channels/Create';

// Bots
import Bots from './views/bots/Index';
import CreateBot from './views/bots/Create';
import UpdateBot from './views/bots/Update';
import ShowBot from './views/bots/Show';

// Channels
import Channels from './views/channels/Index';

// Subscriptions
import Subscriptions from './views/subscriptions/Index';
import ShowSubscription from './views/subscriptions/Show';

// Links
import Links from './views/links/Index';
import CreateBotsLink from './views/links/CreateBotsLink';
import CreateChannelsLink from './views/links/CreateChannelsLink';
import ShowLink from './views/links/Show';

// Managers
import Managers from './views/managers/Index';
import SignInQrCode from './views/managers/SignInQrCode';
import SignInSendCode from './views/managers/SignInSendCode';
import ShowManager from './views/managers/Show';

// Auth Imports
import Signup from './views/auth/SignUp';
import Login from './views/auth/Login';
import SetPassword from './views/auth/SetPassword';
import TwoFactor from './views/auth/TwoFactor';
import NotFound from './views/system/NotFound';
import ForgotPassword from './views/auth/ForgotPassword';
import LinkExpired from './views/auth/LinkExpired';

// Users
import Users from './views/users/Index';
import CreateUser from './views/users/Create';
import UpdateUser from './views/users/Update';

// Users
import CreateUserResource from './views/user-resources/Create';
import UpdateUserResource from './views/user-resources/Update';
import ShowUserResource from './views/user-resources/Show';

// Services
// import Prompts from './views/services/prompts/Index';
// // import CreatePrompt from './views/services/prompts/Create';
// import UpdatePrompt from './views/services/prompts/Update';
// import ShowPrompt from './views/services/prompts/Show';

import Settings from './views/services/settings/Index';
// import CreatePrompt from './views/services/settings/Create';
import UpdateSetting from './views/services/settings/Update';
import ShowSetting from './views/services/settings/Show';

import Actors from './views/services/actors/Index';
import CreateActor from './views/services/actors/Create';
import UpdateActor from './views/services/actors/Update';
import ShowActor from './views/services/actors/Show';

import Groups from './views/services/groups/Index';
import CreateGroup from './views/services/groups/Create';
import UpdateGroup from './views/services/groups/Update';
import ShowGroup from './views/services/groups/Show';

import CreateActorSetting from './views/services/actor-settings/Create';
import UpdateActorSetting from './views/services/actor-settings/Update';
import ShowActorSetting from './views/services/actor-settings/Show';

import DialogMessages from './views/services/dialog_messages/Index';

import UpdateNews from './views/services/news/Update';

import BlackList from './views/services/blackList/Index';
import CreateBlackListItem from './views/services/blackList/Create';

import { RoleE } from './api/types/auth';

export enum ModuleE {
  PROMPTS = 'prompts',
  SETTINGS = 'settings',
  CONTROL = 'control',
  ACTORS = 'actors',
  GROUPS = 'groups',
  PROMPT_SETTINGS = 'promptsettings',
  DIALOG_MESSAGES = 'dialogmessages',
  NEWS = 'news',
  BLACKLIST = 'blacklist',
}

export type PathsParams = {
  [PathsE.UPDATE_SUBSCRIBER]: {
    subscriberId: string
  },
  [PathsE.SHOW_SUBSCRIBER]: {
    subscriberId: string
  },
  [PathsE.UPDATE_BOT]: {
    botId: string
  },
  [PathsE.SHOW_BOT]: {
    botId: string
  },
  [PathsE.UPDATE_CHANNEL]: {
    channelId: string
  },
  [PathsE.SHOW_CHANNEL]: {
    channelId: string
  },
  [PathsE.SHOW_SUBSCRIPTION]: {
    subscriptionId: string
  },
  [PathsE.SHOW_LINK]: {
    linkId: string
  }
  [PathsE.UPDATE_USER]: {
    userId: string
  },
  [PathsE.SHOW_USER]: {
    userId: string
  },
  [PathsE.UPDATE_USER_RESOURCE]: {
    resourceId: string
  },
  [PathsE.SHOW_USER_RESOURCE]: {
    resourceId: string
  },
  // [PathsE.PROMPTS]: {
  //   serviceId: string,
  // },
  // [PathsE.SHOW_PROMPT]: {
  //   serviceId: string,
  //   promptId: string,
  // },
  // [PathsE.UPDATE_PROMPT]: {
  //   serviceId: string,
  //   promptId: string,
  // },
  // [PathsE.CREATE_PROMPT]: {
  //   serviceId: string,
  // },

  [PathsE.SHOW_ACTOR_SETTING]: {
    serviceId: string,
    actorSettingId: string,
  },
  [PathsE.UPDATE_ACTOR_SETTING]: {
    serviceId: string,
    actorSettingId: string,
  },
  [PathsE.CREATE_ACTOR_SETTING]: {
    serviceId: string,
  },
  [PathsE.SETTINGS]: {
    serviceId: string,
  },
  [PathsE.SHOW_SETTING]: {
    serviceId: string,
    settingId: string,
  },
  [PathsE.UPDATE_SETTING]: {
    serviceId: string,
    settingId: string,
  },
  [PathsE.CREATE_SETTING]: {
    serviceId: string,
  },
  [PathsE.ACTORS]: {
    serviceId: string,
  },
  [PathsE.SHOW_ACTOR]: {
    serviceId: string,
    actorId: string,
  },
  [PathsE.UPDATE_ACTOR]: {
    serviceId: string,
    actorId: string,
  },
  [PathsE.CREATE_ACTOR]: {
    serviceId: string,
  },
  [PathsE.GROUPS]: {
    serviceId: string,
  },
  [PathsE.SHOW_GROUP]: {
    serviceId: string,
    groupId: string,
  },
  [PathsE.UPDATE_GROUP]: {
    serviceId: string,
    groupId: string,
  },
  [PathsE.CREATE_GROUP]: {
    serviceId: string,
  },
  [PathsE.DIALOG_MESSAGES]: {
    serviceId: string,
  },
  [PathsE.NEWS]: {
    serviceId: string,
  },
  [PathsE.UPDATE_NEWS]: {
    serviceId: string,
    id: string,
  },
  [PathsE.BLACKLIST]: {
    serviceId: string,
  },
  [PathsE.CREATE_BLACKLIST_ITEM]: {
    serviceId: string,
  },
}
export type SearchParams = {
  [PathsE.UPDATE_SETTING]: {
    page?: string;
    size?: string;
  },
}

export enum PathsE {
  // HOME
  HOME = 'home',

  // AUTH
  SIGN_UP = 'sign-up',
  LOGIN = 'login',
  TWO_FA = 'two-factor',
  SET_PASSWORD = 'set-password',
  FORGOT_PASSWORD = 'forgot-password',

  // SUBSCRIBERS
  SUBSCRIBERS = 'subscribers',
  SHOW_SUBSCRIBER = 'subscribers/:subscriberId',
  CREATE_SUBSCRIBER = 'subscribers/new',
  UPDATE_SUBSCRIBER = 'subscribers/:subscriberId/edit',

  // CHANNELS
  CHANNELS = 'channels',
  SHOW_CHANNEL = 'channels/:channelId',
  CREATE_CHANNEL = 'channels/new',
  UPDATE_CHANNEL = 'channels/:channelId/edit',

  // SUBSCRIPTIONS
  SUBSCRIPTIONS = 'subscriptions',
  SHOW_SUBSCRIPTION = 'subscriptions/:subscriptionId',

  // BOTS
  BOTS = 'bots',
  SHOW_BOT = 'bots/:botId',
  CREATE_BOT = 'bots/new',
  UPDATE_BOT = 'bots/:botId/edit',

  // USERS
  USERS = 'users',
  SHOW_USER = 'users/:userId',
  CREATE_USER = 'users/new',
  UPDATE_USER = 'users/:userId/edit',

  // USERS RESOURCES
  USER_RESOURCES = 'user-resources',
  SHOW_USER_RESOURCE = 'user-resources/:resourceId',
  CREATE_USER_RESOURCE = 'user-resources/new',
  UPDATE_USER_RESOURCE = 'user-resources/:resourceId/edit',

  // LINKS
  LINKS = 'links',
  CREATE_BOTS_LINK = 'links/new-bots-link',
  CREATE_CHANNELS_LINK = 'links/new-channels-link',
  SHOW_LINK = 'links/:linkId',

  // MANAGERS
  MANAGERS = 'managers',
  SHOW_MANAGER = 'managers/:managerId',
  SIGNIN_QR_CODE = 'managers/signin-qr-code',
  SIGNIN_SEND_CODE = 'managers/signin-send-code',
  SIGNIN_SEND_CODE_PASSWORD = 'managers/signin-send-code-password',

  // SERVICES
  // PROMPTS = 'services/:serviceId/prompts',
  // CREATE_PROMPT = 'services/:serviceId/prompts/new',
  // SHOW_PROMPT = 'services/:serviceId/prompts/:promptId',
  // UPDATE_PROMPT = 'services/:serviceId/prompts/:promptId/edit',

  // ACTOR_SETTINGS
  CREATE_ACTOR_SETTING = 'services/:serviceId/actor-settings/new',
  SHOW_ACTOR_SETTING = 'services/:serviceId/actor-settings/:actorSettingId',
  UPDATE_ACTOR_SETTING = 'services/:serviceId/actor-settings/:actorSettingId/edit',

  // SETTINGS
  SETTINGS = 'services/:serviceId/settings',
  CREATE_SETTING = 'services/:serviceId/settings/new',
  SHOW_SETTING = 'services/:serviceId/settings/:settingId',
  UPDATE_SETTING = 'services/:serviceId/settings/:settingId/edit',

  // ACTORS
  ACTORS = 'services/:serviceId/actors',
  CREATE_ACTOR = 'services/:serviceId/actors/new',
  SHOW_ACTOR = 'services/:serviceId/actors/:actorId',
  UPDATE_ACTOR = 'services/:serviceId/actors/:actorId/edit',

  // GROUPS
  GROUPS = 'services/:serviceId/lenta',
  CREATE_GROUP = 'services/:serviceId/lenta/new',
  SHOW_GROUP = 'services/:serviceId/lenta/:groupId',
  UPDATE_GROUP = 'services/:serviceId/lenta/:groupId/edit',
  
  // DIALOG_MESSAGES
  DIALOG_MESSAGES = 'services/:serviceId/dialog_messages',

  // NEWS
  NEWS = 'services/:serviceId/news',
  UPDATE_NEWS = 'services/:serviceId/news/:id/edit',

  // BLACKLIST
  BLACKLIST = 'services/:serviceId/blacklist',
  CREATE_BLACKLIST_ITEM = 'services/:serviceId/blacklist/new',

  // HIDDEN
  DEFAULT = 'default',
  NFT = 'nft-marketplace',
  DATA_TABLES = 'data-tables',
  PROFILE = 'profile',

  // SYSTEM
  NOT_FOUND = '404',
  LINK_EXPIRED = 'expired',
}

export enum LayoutsE {
  AUTH = 'auth',
  DASHBOARD = 'dashboard',
  SYSTEM = 'system',
}

export enum GroupE {
  TG = 'TG Metrics',
  AI = 'AI'
}

export type RouteT = {
  name?: string
  isDisabled: boolean
  isShowInNav: boolean
  path: PathsE
  component: () => JSX.Element
  icon?: JSX.Element
  secondary?: boolean
  layout?: LayoutsE,
  access?: RoleE[]
}

export interface GroupT {
  group?: GroupE,
  icon?: JSX.Element
  routes: RouteT[]
}

export type LayoutT = {
  [key in LayoutsE]: {
    isProtected: boolean;
    isHideInAuth: boolean;
    groups: GroupT[];
  };
}

const iconStyles = { size: 24 as IconSizeT, fill: true, variant: "outlined" as IconVariantT, color: "inherit" };

// Access rules!!!
// --------------------------------------
// No access array -> All view
// [] -> Only admin
// [RoleE.MANAGER] -> Only manager and admin
// --------------------------------------


const useRoutes = () => {
  const { t } = useTranslation();

  const groups: LayoutT = {
    [LayoutsE.AUTH]: {
      isHideInAuth: true,
      isProtected: false,
      groups: [{
        routes: [
          {
            path: PathsE.LOGIN,
            component: Login,
            isDisabled: false,
            isShowInNav: false,
          },
          {
            path: PathsE.SIGN_UP,
            component: Signup,
            isDisabled: false,
            isShowInNav: false,
          },
          {
            path: PathsE.TWO_FA,
            component: TwoFactor,
            isDisabled: false,
            isShowInNav: false,
          },
          {
            path: PathsE.SET_PASSWORD,
            component: SetPassword,
            isDisabled: false,
            isShowInNav: false,
          },
          {
            path: PathsE.FORGOT_PASSWORD,
            component: ForgotPassword,
            isDisabled: false,
            isShowInNav: false,
          },
        ]
      }],
    },
    [LayoutsE.DASHBOARD]: {
      isHideInAuth: false,
      isProtected: true,
      groups: [
        {
          icon: <MuiIcon name="group" {...iconStyles} />,
          group: GroupE.TG,
          routes: [
            // // SUBSCRIBERS
            // {
            //   name: t('subscribers.subscribers'),
            //   path: PathsE.SUBSCRIBERS,
            //   icon: <MuiIcon name="admin_panel_settings" {...iconStyles} />,
            //   component: Subscribers,
            //   isDisabled: false,
            //   isShowInNav: true,
            // },
            // {
            //   name: t('subscribers.createSubscriber'),
            //   path: PathsE.CREATE_SUBSCRIBER,
            //   component: CreateSubscriber,
            //   isDisabled: false,
            //   isShowInNav: false,
            // },
            // {
            //   name: t('subscribers.viewSubscriber'),
            //   path: PathsE.SHOW_SUBSCRIBER,
            //   component: ShowSubscriber,
            //   isDisabled: false,
            //   isShowInNav: false,
            // },
            // {
            //   name: t('subscribers.editSubscriber'),
            //   path: PathsE.UPDATE_SUBSCRIBER,
            //   component: UpdateSubscriber,
            //   isDisabled: false,
            //   isShowInNav: false,
            // },
            // CHANNELS
            {
              name: t('channels.channels'),
              path: PathsE.CHANNELS,
              icon: <MuiIcon name="group" {...iconStyles} />,
              component: Channels,
              isDisabled: false,
              isShowInNav: true,
            },
            {
              name: t('channels.createChannel'),
              path: PathsE.CREATE_CHANNEL,
              component: CreateChannel,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('channels.viewChannel'),
              path: PathsE.SHOW_CHANNEL,
              component: ShowChannel,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('subscriptions.viewSubscription'),
              path: PathsE.SHOW_SUBSCRIPTION,
              component: ShowSubscription,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('subscriptions.subscriptions'),
              path: PathsE.SUBSCRIPTIONS,
              icon: <MuiIcon name="subscriptions" {...iconStyles} />,
              component: Subscriptions,
              isDisabled: false,
              isShowInNav: true,
            },
            // BOTS
            {
              name: t('bots.bots'),
              path: PathsE.BOTS,
              icon: <MuiIcon name="smart_toy" {...iconStyles} />,
              component: Bots,
              isDisabled: false,
              isShowInNav: true,
            },
            {
              name: t('bots.createBot'),
              path: PathsE.CREATE_BOT,
              component: CreateBot,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('bots.viewBot'),
              path: PathsE.SHOW_BOT,
              component: ShowBot,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('bots.editBot'),
              path: PathsE.UPDATE_BOT,
              component: UpdateBot,
              isDisabled: false,
              isShowInNav: false,
            },
            // LINKS
            {
              name: t('dtos.link', { count: 5 }),
              path: PathsE.LINKS,
              icon: <MuiIcon name="link" {...iconStyles} />,
              component: Links,
              isDisabled: false,
              isShowInNav: true,
            },
            {
              name: t('links.viewLink'),
              path: PathsE.SHOW_LINK,
              component: ShowLink,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('links.createBotsLink'),
              path: PathsE.CREATE_BOTS_LINK,
              component: CreateBotsLink,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('links.createChannelsLink'),
              path: PathsE.CREATE_CHANNELS_LINK,
              component: CreateChannelsLink,
              isDisabled: false,
              isShowInNav: false,
            },
            // MANAGERS
            {
              name: t('managers.managers'),
              path: PathsE.MANAGERS,
              icon: <MuiIcon name="engineering" {...iconStyles} />,
              component: Managers,
              isDisabled: false,
              isShowInNav: true,
            },
            {
              name: t('managers.signInQrCode'),
              path: PathsE.SIGNIN_QR_CODE,
              component: SignInQrCode,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('managers.signInSendCode'),
              path: PathsE.SIGNIN_SEND_CODE,
              component: () => <SignInSendCode />,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('managers.signInSendCodeAndPassword'),
              path: PathsE.SIGNIN_SEND_CODE_PASSWORD,
              component: () => <SignInSendCode passwordMode />,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('managers.viewManager'),
              path: PathsE.SHOW_MANAGER,
              component: ShowManager,
              isDisabled: false,
              isShowInNav: false,
            },
            // {
            //   name: t('managers.editManager'),
            //   path: PathsE.UPDATE_MANAGER,
            //   component: UpdateManager,
            //   isDisabled: false,
            //   isShowInNav: false,
            // },
            // USERS
            {
              name: t('users.users'),
              path: PathsE.USERS,
              icon: <MuiIcon name="group" {...iconStyles} />,
              component: Users,
              isDisabled: false,
              isShowInNav: true,
              access: [],
            },
            {
              name: t('users.createUser'),
              path: PathsE.CREATE_USER,
              component: CreateUser,
              isDisabled: false,
              isShowInNav: false,
              access: [],
            },
            // {
            //   name: t('users.viewUser'),
            //   path: PathsE.SHOW_USER,
            //   component: ShowUser,
            //   isDisabled: false,
            //   isShowInNav: false,
            //   access: [],
            // },
            {
              name: t('users.editUser'),
              path: PathsE.UPDATE_USER,
              component: UpdateUser,
              isDisabled: false,
              isShowInNav: false,
              access: [],
            },
            // USER RESOURCES
            // {
            //   name: t('users.usersResources'),
            //   path: PathsE.USER_RESOURCES,
            //   icon: <MuiIcon name="folder_shared" {...iconStyles} />,
            //   component: UserResources,
            //   isDisabled: false,
            //   isShowInNav: true,
            //   access: [],
            // },
            {
              name: t('users.createUserResource'),
              path: PathsE.CREATE_USER_RESOURCE,
              component: CreateUserResource,
              isDisabled: false,
              isShowInNav: false,
              access: [],
            },
            {
              name: t('users.viewUserResource'),
              path: PathsE.SHOW_USER_RESOURCE,
              component: ShowUserResource,
              isDisabled: false,
              isShowInNav: false,
              access: [],
            },
            {
              name: t('users.editUserResource'),
              path: PathsE.UPDATE_USER_RESOURCE,
              component: UpdateUserResource,
              isDisabled: false,
              isShowInNav: false,
              access: [],
            },
          ],
        },
        {
          group: GroupE.AI,
          icon: <MuiIcon name="smart_toy" {...iconStyles} />,
          routes: [
            // SERVICES
            // {
            //   name: t('services.prompts'),
            //   path: PathsE.PROMPTS,
            //   component: Prompts,
            //   isDisabled: false,
            //   isShowInNav: false,
            // },
            // {
            //   name: t('services.viewPrompt'),
            //   path: PathsE.SHOW_PROMPT,
            //   component: ShowPrompt,
            //   isDisabled: false,
            //   isShowInNav: false,
            // },
            // {
            //   name: t('services.editPrompt'),
            //   path: PathsE.UPDATE_PROMPT,
            //   component: UpdatePrompt,
            //   isDisabled: false,
            //   isShowInNav: false,
            // },

            {
              name: t('services.createActorSetting'),
              path: PathsE.CREATE_ACTOR_SETTING,
              component: CreateActorSetting,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('services.viewActorSetting'),
              path: PathsE.SHOW_ACTOR_SETTING,
              component: ShowActorSetting,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('services.editActorSetting'),
              path: PathsE.UPDATE_ACTOR_SETTING,
              component: UpdateActorSetting,
              isDisabled: false,
              isShowInNav: false,
            },

            // SETTINGS
            {
              name: t('services.settings'),
              path: PathsE.SETTINGS,
              component: Settings,
              isDisabled: false,
              isShowInNav: true,
            },
            // {
            //   name: t('services.createPrompt'),
            //   path: PathsE.CREATE_PROMPT,
            //   component: CreatePrompt,
            //   isDisabled: false,
            //   isShowInNav: false,
            // },
            {
              name: t('services.viewSetting'),
              path: PathsE.SHOW_SETTING,
              component: ShowSetting,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('services.editSetting'),
              path: PathsE.UPDATE_SETTING,
              component: UpdateSetting,
              isDisabled: false,
              isShowInNav: false,
            },

            // ACTORS
            {
              name: t('services.actors'),
              path: PathsE.ACTORS,
              component: Actors,
              isDisabled: false,
              isShowInNav: true,
            },
            {
              name: t('services.createActor'),
              path: PathsE.CREATE_ACTOR,
              component: CreateActor,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('services.viewActor'),
              path: PathsE.SHOW_ACTOR,
              component: ShowActor,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('services.editActor'),
              path: PathsE.UPDATE_ACTOR,
              component: UpdateActor,
              isDisabled: false,
              isShowInNav: false,
            },

            // GROUPS
            {
              name: t('services.dialogs'),
              path: PathsE.GROUPS,
              component: Groups,
              isDisabled: false,
              isShowInNav: true,
            },
            {
              name: t('services.createGroup'),
              path: PathsE.CREATE_GROUP,
              component: CreateGroup,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('services.viewGroup'),
              path: PathsE.SHOW_GROUP,
              component: ShowGroup,
              isDisabled: false,
              isShowInNav: false,
            },
            {
              name: t('services.editGroup'),
              path: PathsE.UPDATE_GROUP,
              component: UpdateGroup,
              isDisabled: false,
              isShowInNav: false,
            },

            // DIALOG MESSAGES
            {
              name: t('services.Dialog messages'),
              path: PathsE.DIALOG_MESSAGES,
              component: DialogMessages,
              isDisabled: false,
              isShowInNav: false,
            },

            {
              name: t('services.editNews'),
              path: PathsE.UPDATE_NEWS,
              component: UpdateNews,
              isDisabled: false,
              isShowInNav: false,
            },

            {
              name: 'Black List',
              path: PathsE.BLACKLIST,
              component: BlackList,
              isDisabled: false,
              isShowInNav: true,
            },
            {
              name: t('services.createBlackListItem'),
              path: PathsE.CREATE_BLACKLIST_ITEM,
              component: CreateBlackListItem,
              isDisabled: false,
              isShowInNav: false,
            },


          ],
        }
      ]
    },
    [LayoutsE.SYSTEM]: {
      isHideInAuth: false,
      isProtected: false,
      groups: [{
        routes: [
          {
            name: t('general.pageNotFound'),
            path: PathsE.NOT_FOUND,
            component: NotFound,
            isDisabled: false,
            isShowInNav: false,
          },
          {
            path: PathsE.LINK_EXPIRED,
            component: LinkExpired,
            isDisabled: false,
            isShowInNav: false,
          },
        ]
      }],
    },
  };

  return groups;
}

export default useRoutes;
